if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        this.stock = this.querySelector('[data-product-stock]');
        this.inStock = this.querySelector('[data-in-stock]');
        this.lowStock = this.querySelector('[data-low-in-stock]');
        this.noStock = this.querySelector('[data-out-of-stock]');
        this.isConcierge = this.querySelector('[data-concierge-stock]');
        this.variantPrice = this.querySelector('[data-product-card-main-price-el]');
        this.addToCartDeliveryProperty = document.querySelector('[data-estimated-arrival]');
        this.colorLabel = this.querySelector('.variant-swatches [data-variant-color-text]');
        this.addToCartPrice = this.querySelector('.product-form__submit [data-add-to-cart-price]');

        const variants = this.querySelector('[data-product-variants]');
        if (variants) {
          this.variants = JSON.parse(variants.textContent);
        }
        

        const messages_script = this.querySelector('[data-oos-messages]');
        if (messages_script) {
          
          this.messages = JSON.parse(this.querySelector('[data-oos-messages]').textContent);
        }
        

        this.initVariantSelects()
      }

      getVariant(option1 = null, option2 = null, option3 = null) {
        let productData = JSON.parse(this.querySelector('[data-product-info]').textContent);
        productData['variants'].forEach((variant) => {
          if (variant['option1'] === option1 && variant['option2'] === option2 && variant['option3'] === option3) {
            // Change price
            this.variantPrice.innerHTML = this.variantPrice.dataset.priceFormat.replace('{{amount}}', parseFloat(variant['price'] / 100).toFixed(2));

            // Change ID
            document.querySelector('[data-product-form-selected-variant-el]').value = variant['id'];
          }
        });
      }

      initVariantSelects () {
        if (!this.variantSelects) return;
        this.legend = this.variantSelects.querySelector('legend')
        this.legendValue = this.legend.querySelector('[data-variant-text]')
        this.labels = this.variantSelects.querySelectorAll('label')

        if (typeof this.legend === 'undefined' || typeof this.labels === 'undefined') { return }

        this.labels.forEach(label => {
          label.addEventListener('click', (event) => {
            const labelValue = label.getAttribute('data-label-value');
            const variableStock = Number(label.getAttribute('data-variant-stock'));
            const legendLabel = event.currentTarget.closest('fieldset').querySelector('[data-variant-text]');

            let options = [];
            let selectedValues = this.querySelectorAll('.product-form__input input:checked + label');
            if (selectedValues) {
              selectedValues.forEach((value) => {
                options.push(value.dataset.variantOptionValue);
              });
            }

            const variantOption = event.currentTarget.closest('fieldset').dataset.index;
            options[variantOption] = event.currentTarget.dataset.variantOptionValue;

            if (event.currentTarget.getAttribute('data-change-color')) {
              if (this.messages) {
                let variantOption = '';
                options.forEach((option) => {
                  variantOption += option;
                  variantOption += '/';
                });
                variantOption = variantOption.slice(0, -1);
                let value = this.messages.filter((data) => {return data.options === variantOption});
                if (value[0].title) {
                  this.colorLabel.innerText = this.colorLabel.dataset.initialMessage.replace(`[${event.currentTarget.dataset.optionName}]` ,value[0].title);
                } else {
                 this.colorLabel.innerText = this.colorLabel.dataset.initialMessage;
                }
              }
            }

            if (legendLabel) {
              if (event.currentTarget.getAttribute('data-change-color')) {
                
                let variantOption = '';
                options.forEach((option) => {
                  variantOption += option;
                  variantOption += '/';
                });
                variantOption = variantOption.slice(0, -1);
                let value = this.messages.filter((data) => {return data.options === variantOption});
                if (value[0].title) {
                  legendLabel.textContent = value[0].title;
                } else {
                 legendLabel.textContent = labelValue; 
                }
              } else {
                legendLabel.textContent = labelValue;
              }
            }

            if (selectedValues.length === 1) {
              this.getVariant(options[0]);
            } else if (selectedValues.length === 2) {
              this.getVariant(options[0], options[1]);
            } else if (selectedValues.length === 3) {
              this.getVariant(options[0], options[1], options[2]);
            }
            
            // Update stock message   
            this.addToCartDeliveryProperty.disabled = false;
            if (typeof this.stock !== 'undefined') {
              if (variableStock <= 0) {
                if (event.currentTarget.dataset.variantOptionValue.includes('Concierge')) {
                  this.stock.dataset.productStock = 'special';
                  this.addToCartDeliveryProperty.value = this.isConcierge.querySelector('p').innerHTML;
                } else {
                  if (event.currentTarget.dataset.daysToArrive) {
                    this.noStock.querySelector('p').textContent = event.currentTarget.dataset.daysToArrive;
                    if (event.currentTarget.dataset.deliveryEstimation) {
                      this.addToCartDeliveryProperty.value = event.currentTarget.dataset.deliveryEstimation; 
                    } else {
                      this.addToCartDeliveryProperty.value = this.noStock.querySelector('p').innerHTML; 
                    }
                  }
                  if (this.messages) {
                    let variantOption = '';
                    options.forEach((option) => {
                      variantOption += option;
                      variantOption += '/';
                    });
                    variantOption = variantOption.slice(0, -1);
                    let value = this.messages.filter((data) => {return data.options === variantOption});
                    if (value[0].message) {
                      this.noStock.querySelector('p').innerText = value[0].message;
                      this.addToCartDeliveryProperty.value = value[0].message;
                    }
                  }
                  this.stock.dataset.productStock = 'out'; 
                }
              } else if (variableStock <= 3) {
                this.stock.dataset.productStock = 'low';
                this.lowStock.querySelector('p').textContent = this.lowStock.dataset.message.replace('{{ quantity }}', variableStock);
                this.addToCartDeliveryProperty.value = this.lowStock.dataset.message.replace('{{ quantity }}', variableStock);
              } else {
                this.stock.dataset.productStock = 'normal';
                this.addToCartDeliveryProperty.disabled = true;
              }
            }

            // Update price on add to cart

            if (this.addToCartPrice && this.variants) {
              let title = '';
              options.forEach((option) => {
                title += option + ' / ';
              });
              title = title.substring(0, title.length-3);
              this.variants.forEach((variant) => {
                if (variant.title === title) {
                  const price = (variant.price / 100).toFixed(2);               
                  if (this.addToCartPrice.dataset.format.includes('{{amount}}')) {
                    this.addToCartPrice.textContent = this.addToCartPrice.dataset.format.replace('{{amount}}', price); 
                  }
                  if (this.addToCartPrice.dataset.format.includes('{{amount_with_comma_separator}}')) {
                    this.addToCartPrice.textContent = this.addToCartPrice.dataset.format.replace('{{amount_with_comma_separator}}', price); 
                  }
                }
              });
            }
          })
        })
      }

      changeMaterialLabels(text) {
        let elements = [];
        let values = this.colorLabel.innerText.split(',');

        let newValue = text + "," + values[1];
        this.colorLabel.innerText = newValue;

        
        // let xpath = `//*[contains(text(), '${values[0]}')]`;
        // let matchingElements = document.evaluate(xpath, document, null, XPathResult.ORDERED_NODE_ITERATOR_TYPE, null)

        // let element = null;
        // while (element = matchingElements.iterateNext()) {
        //   if (element.closest('.product__accordion')) {
        //     elements.push(element);
        //   }
        // }

        // xpath = `//*[contains(text(), '${values[0].toLowerCase()}')]`;
        // matchingElements = document.evaluate(xpath, document, null, XPathResult.ORDERED_NODE_ITERATOR_TYPE, null)

        // while (element = matchingElements.iterateNext()) {
        //   if (element.closest('.product__accordion')) {
        //     elements.push(element);
        //   }
        // }

        // let newValue;
        // elements.forEach(item => {
        //   if (item.innerHTML.includes('10k') || item.innerHTML.includes('12k') || item.innerHTML.includes('14k') || item.innerHTML.includes('16k') || item.innerHTML.includes('18k')) {
        //     if (item.innerText.includes(values[0])) {
        //       item.innerHTML = item.innerHTML.replace(values[0], text);
        //     } else if (item.innerText.includes(values[0].toLowerCase())) {
        //       item.innerHTML = item.innerHTML.replace(values[0].toLowerCase(), text.toLowerCase());
        //     }
        //   }
        // })
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
